// Ruta: frontend/src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './core/context/AuthContext';
import { useAuth } from './core/hooks/useAuth'; // ✅ IMPORTACIÓN FALTANTE
import { ChecklistProvider } from './core/context/ChecklistContext';
import MainLayout from './shared/layout/MainLayout';
import AuthLayout from './shared/layout/AuthLayout';
import LoginPage from './modules/auth/pages/LoginPage';
import RegisterPage from './modules/auth/pages/RegisterPage';
import ChecklistListPage from './modules/checklists/pages/ChecklistListPage';
import ChecklistCreatePage from './modules/checklists/pages/ChecklistCreatePage';
import ChecklistEditPage from './modules/checklists/pages/ChecklistEditPage';
import ChecklistDetailPage from './modules/checklists/pages/ChecklistDetailPage';
import ScannerPage from './modules/inspections/pages/ScannerPage';
import InspectionFormPage from './modules/inspections/pages/InspectionFormPage';
import InspectionPage from './modules/inspections/pages/InspectionPage';
import ReportPage from './modules/inspections/pages/ReportPage';
import DashboardPage from './modules/admin/pages/DashboardPage';

// Componente para proteger rutas
const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="text-center py-12">Cargando...</div>;
  if (!user) return <Navigate to="/auth/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="checklists" element={<PrivateRoute><ChecklistListPage /></PrivateRoute>} />
        <Route path="checklists/create" element={<PrivateRoute><ChecklistCreatePage /></PrivateRoute>} />
        <Route path="checklists/:id" element={<PrivateRoute><ChecklistDetailPage /></PrivateRoute>} />
        <Route path="checklists/:id/edit" element={<PrivateRoute><ChecklistEditPage /></PrivateRoute>} />
        <Route path="scanner" element={<PrivateRoute><ScannerPage /></PrivateRoute>} />
        <Route path="inspection/:id" element={<PrivateRoute><InspectionFormPage /></PrivateRoute>} />
        <Route path="inspections/:id" element={<PrivateRoute><InspectionPage /></PrivateRoute>} />
        <Route path="report/:id" element={<PrivateRoute><ReportPage /></PrivateRoute>} />
      </Route>
      <Route path="/auth" element={<AuthLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ChecklistProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ChecklistProvider>
    </AuthProvider>
  );
}

export default App;